const NewsItem = ({ date, title, message, links = [] }) => {
  return (
    <div className='news-item'>
      <div className='news-item-date'>{date}</div>
      <div className='news-item-title'>{title}</div>

      <div className='news-item-message'>
        {message.split('\n\n').map((paragraph, i) => (
          <p key={i}>
            {paragraph.split('\n').map((line, j) => (
              <span key={j}>
                {line}
                <br />
              </span>
            ))}
          </p>
        ))}
      </div>

      {links.length > 0 && (
        <div className='news-item-links'>
          {links.map((link, i) => (
            <a
              key={i}
              href={link.href}
              target={link.target || '_self'}
              rel='noopener noreferrer'
              className='news-item-link'
            >
              {link.label}
            </a>
          ))}
        </div>
      )}
    </div>
  )
}

export default NewsItem
